export const UserAccessType = {
    Association: 'ASSOCIATION_DATA',
    Network: 'NETWORK_DATA',
    Shipper: 'SHIPPER_DATA'
};

export const UserAccessTypes = [
    UserAccessType.Association,
    UserAccessType.Network,
    UserAccessType.Shipper
];
